module.exports = __webpack_public_path__ + "img/v3-comm-prop.574fb7bd.png";